<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="panel">
                    <div class="panel__header">
                        <h2>
                            <i class="panel__header__icon icons icon-people"></i>
                            <span>{{$t('work_processes.title')}}</span>
                        </h2>
                    </div>
                    <div class="panel__body">
                        <work-processes-table />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import WorkProcessesTable from '@/components/tables/work-processes/WorkProcessesTable';

    @Component({
        components: {
            WorkProcessesTable,
        }
    })
    export default class WorkProcesses extends Vue {
        name = 'work-processes';
    }

    Vue.component('work-processes', WorkProcesses);
</script>



// WEBPACK FOOTER //
// src/pages/WorkProcesses.vue